import { useCallback } from 'react';
import { IoIosTrash } from 'react-icons/io';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useHistory } from 'react-router';
import SyncLoader from 'react-spinners/SyncLoader';
import ReactTooltip from 'react-tooltip';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { floatToCurrency } from '../../../commons/currency-formatter';
import Footer from '../../../components/footer-for-scrooling';
import SortButton from '../../../components/sort-desc/SortButton';

const ProductsTable = ({
  products,
  page,
  setItemDelete,
  params,
  setParams,
  loading,
  setScrolling,
}) => {
  const history = useHistory();

  const changePage = useCallback(() => {
    setScrolling(true);
    setParams((prevState) => ({
      ...prevState,
      current_page: page.current_page + 1,
    }));
  }, [page]);

  const sortProducts = useCallback(
    (field, sort) => {
      setParams((prevState) => ({
        ...prevState,
        sorts: `${field}:${sort}`,
        per_page: products.length,
      }));
    },
    [products]
  );

  return (
    <Container>
      <div className="col-12 text-center mt-5">
        <h6>
          TOTAL DE REGISTROS - {products.length} de <b>{page?.total}</b>
        </h6>
      </div>

      <div className="row mt-3">
        <div className="col">
          <InfiniteScroll
            dataLength={products.length}
            next={changePage}
            hasMore={page.has_next_page}
            loader={
              <div className="col text-center">
                {loading && (
                  <SyncLoader color="#F7931E" size={15} margin={10} />
                )}
              </div>
            }
            endMessage={
              <div className="col text-center">
                <h6>
                  TOTAL DE REGISTROS - {products.length} de <b>{page?.total}</b>
                </h6>
              </div>
            }
          >
            <div className="table-responsive">
              <table className="table table-hover text-center">
                <thead>
                  <tr>
                    <th scope="col" className="text-start">
                      <SortButton
                        label="NOME"
                        params={params}
                        ascFunction={() => sortProducts('name', 'ASC')}
                        descFunction={() => sortProducts('name', 'DESC')}
                      />
                    </th>
                    <th scope="col">DESCRIÇÃO</th>
                    <th scope="col">TIPO</th>
                    <th scope="col">UNIDADE</th>
                    <th scope="col">PREÇO</th>
                    <th scope="col">STATUS</th>
                    <th scope="col" className="text-end">
                      AÇÃO
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {products.map((item) => (
                    <tr
                      key={item.id}
                      className={
                        item.is_active === false ? 'inactive-product' : ''
                      }
                      onClick={(e) => {
                        if (e.target.innerText !== undefined) {
                          history.push(`products/${item.id}`);
                        }
                      }}
                    >
                      <td className="text-start">{item.name}</td>
                      <td className="text-start">{item.finish_type}</td>
                      <td>{item.type}</td>
                      <td>{item.unit}</td>
                      <td>{floatToCurrency(item.price)}</td>
                      <td>
                        {item.is_active === false ? (
                          <StatusBadge $inactive>Inativo</StatusBadge>
                        ) : (
                          <StatusBadge>Ativo</StatusBadge>
                        )}
                      </td>

                      <td className="text-end action">
                        <IoIosTrash
                          size={25}
                          className="mb-1"
                          data-tip="Excluir"
                          onClick={() =>
                            setItemDelete({
                              id: item.id,
                              description: item.name,
                            })
                          }
                          data-bs-toggle="modal"
                          data-bs-target="#modal-product"
                        />
                        <ReactTooltip />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </InfiniteScroll>
        </div>
      </div>

      <Footer />
    </Container>
  );
};

ProductsTable.propTypes = {
  products: PropTypes.arrayOf(Object).isRequired,
  page: PropTypes.shape().isRequired,
  setItemDelete: PropTypes.func.isRequired,
  setParams: PropTypes.func.isRequired,
  params: PropTypes.shape().isRequired,
  loading: PropTypes.bool.isRequired,
  setScrolling: PropTypes.func.isRequired,
};

export default ProductsTable;

export const Container = styled.section`
  /* text-transform: uppercase; */

  height: 100vh;

  h6 {
    font-size: 12px;
  }

  .table-hover {
    cursor: pointer;
  }

  .action {
    color: #d11515;

    :hover {
      cursor: pointer;
      color: #ec4646;
    }
  }

  /* Linhas de produtos inativos: texto vermelho discreto + leve fundo */
  tr.inactive-product td {
    color: #b71c1c;
    background-color: #fff5f5;
  }
  tr.inactive-product:hover td {
    background-color: #ffe9e9;
  }

  @media screen and (max-width: 768px) {
    .table {
      width: 900px !important;
    }
  }
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: ${(props) => (props.$inactive ? '#ffffff' : '#1b5e20')};
  background-color: ${(props) => (props.$inactive ? '#d11515' : '#c8e6c9')};
`;
